const map = {
  "Draft": "pill-draft",
  "Pending Approval": "pill-pending",
  "Approved": "pill-approved",
  "Scheduled": "pill-scheduled",
  "Published": "pill-published",
  "Changes Required": "pill-revision",
  "Revision Requested": "pill-revision",
  "Active": "pill-approved",
  "Onboarding": "pill-scheduled",
  "Paused": "pill-pending",
  "Ended": "pill-draft",
};

export function StatusPill({ status }) {
  const cls = map[status] || "pill-draft";
  return (
    <span className={`pill ${cls}`} data-testid={`status-pill-${(status||'').toLowerCase().replace(/\s+/g,'-')}`}>
      <span className="w-1 h-1 rounded-full bg-current" />
      {status}
    </span>
  );
}
